import VerifyBtn from '@/components/VerifyBtn/VerifyBtn';
import { accountManagementApi } from '@/api/user/accountManagementApi';
import { mapGetters, mapActions } from 'vuex';
import QrCode from '@/components/QrCode/QrCode';
import { getErrorLabelMixin } from '@/common/mixin/getErrorLabel';
import { actionTypes } from '@/store/action-types';
import { getterTypes } from '@/store/getter-types';
import { MXWRegister } from 'mxw-register-sdk-web';
import { maxRegisterApi } from '@/api/maxRegisterApi';

export default {
  name: 'GoogleVerificationBind',
  mixins: [getErrorLabelMixin],
  data() {
    return {
      maxRegisterModalShow: false,
      qrString: '',
      withKyc: false,
      isConnected: false,
      mxwRegister: null,
      mxwRegisterUrl: window.env.mxwRegister.url,
      mxwRegisterPath: window.env.mxwRegister.path,
      maxWalletModalShow: true,
      maxWalletPkgType: 'BIND',
      imgStep1: require('@/assets/images/account/max-register-step-1.png'),
      imgStep2: require('@/assets/images/account/max-register-step-2.png'),
      imgStep3: require('@/assets/images/account/max-register-step-3.png'),
      btnList: {
        max_ios_store: { icon: require('@/assets/images/home/grx_ios_store.svg'), path: '' },
        max_android_store: { icon: require('@/assets/images/home/grx_android_store.svg'), path: '' },
      },
      btnList2: {
        max_ipa: { icon: require('@/assets/images/home/max_ios_ipa.png'), path: '' },
        max_apk: { icon: require('@/assets/images/home/max_android_apk.png'), path: '' },
      },
      rowPadding: '0 0 15px 0',
      bodyPadding: '0px 200px 15px 20px',
      pkgType: 'BIND'
    };
  },
  methods: {
    ...mapActions([actionTypes.GET_USERINFO_ACTION, 'getMxwPkgInfo_action']),
    // 开启谷歌验证按钮点击事件
    confirmBtnClick() {
      this.$v.form.$touch();
      if (this.$v.form.$error || this.committing) {
        return;
      }
      this.committing = true;

      let data = {};
      // data.emailCode = this.form.validateCode;
      data.gaSecret = this.form.secret;
      data.gaCode = this.form.code;
      this._requestSetGoogleVerify(data);
    },
    // 获取秘钥
    async getSecret() {
      let res = await accountManagementApi.gaGenerate();
      let data = res.data;
      if (data) {
        this.secretLoaded = true;
      }
      this.form.secret = data.secretKey;
      this.deviceName = data.label;
      this.otpAuthTotpURL = data.otpAuthTotpURL;

      this.createQRCode();
    },
    // 查看谷歌验证按钮点击事件
    checkVerifyBtnClick() {
      this.$v.googleVerificationCheck.$touch();
      if (this.$v.googleVerificationCheck.$error || this.googleVerificationCheck.committing) {
        return;
      }
      this.googleVerificationCheck.committing = true;
      this._requestCheckGoogleVerify(this.googleVerificationCheck.code);
    },
    // 关闭谷歌验证按钮点击事件
    closeGaVerifyBtnClick() {
      this.$v.closeData.$touch();
      let req = /^\d{6}$/;
      let data = {};
      data.status = this.enableGaCheck === 1 ? 0 : 1;
      if (this.Getter_User_Info.enableEmailCheck) {
        if (this.closeData.emailCode && req.test(this.closeData.emailCode)) {
          data.emailCode = this.closeData.emailCode;
        } else {
          return;
        }
      }
      if (this.Getter_User_Info.enablePhoneCheck) {
        if (this.closeData.phoneCode && req.test(this.closeData.phoneCode)) {
          data.phoneCode = this.closeData.phoneCode;
        } else {
          return;
        }
      }
      if (this.closeData.code && req.test(this.closeData.code)) {
        data.gaCode = this.closeData.code;
      } else {
        return;
      }
      /* if (this.$v.closeData.$error || this.closeData.committing) {
        return;
      } */
      this.closeData.committing = true;
      this._requestCloseGoogleVerify(data);
    },
    // 生成二维码
    createQRCode() {
      if (!this.qrcodeObj) {
        this.qrcodeObj = new QRCode('google_code_qrcode', {
          text: this.otpAuthTotpURL,
          width: 108,
          height: 108,
          // colorDark : "#000000",
          // colorLight : "#ffffff",
          // (容错级别,支持L,M,H)Low/Middle/High
          // correctLevel : QRCode.CorrectLevel.H
        });
      } else {
        // 生成另外一个二维码
        this.qrcodeObj.makeCode(this.otpAuthTotpURL);
      }
    },
    // 生成查看谷歌验证二维码
    createQRCode2() {
      if (!this.qrcodeObj2) {
        this.qrcodeObj2 = new QRCode('view_qrcode', {
          text: this.googleVerificationCheck.otpAuthTotpURL,
          width: 108,
          height: 108,
          // colorDark : "#000000",
          // colorLight : "#ffffff",
          // (容错级别,支持L,M,H)Low/Middle/High
          // correctLevel : QRCode.CorrectLevel.H
        });
      } else {
        // 生成另外一个二维码
        this.qrcodeObj2.makeCode(this.googleVerificationCheck.otpAuthTotpURL);
      }
    },
    // 查看谷歌验证器
    _requestCheckGoogleVerify(code) {
      let checkData = this.googleVerificationCheck;
      accountManagementApi.checkGoogleVerify(code)
        .then(res => {
          let data = res.data;
          checkData.deviceName = data.label;
          checkData.otpAuthTotpURL = data.otpAuthTotpURL;
          checkData.secret = data.secret_key;

          checkData.committing = false;
          checkData.step = 'step2';
          this.$nextTick(() => {
            this.createQRCode2();
          });
        })
        .catch((err) => {
          checkData.committing = false;
        });
    },
    // 关闭谷歌验证器
    _requestCloseGoogleVerify(data) {
      accountManagementApi.closeGoogleVerify(data)
        .then(res => {
          this.closeData.committing = false;
          if (res.errcode === 0) {
            this.$q.notify({
              message: data.status === 1 ? '谷歌验证器已开启' : '谷歌验证器已关闭',
              // 可用的值: 'positive', 'negative', 'warning', 'info'
              type: 'positive',
              position: 'top', // 'top', 'left', 'bottom-left'等
            });
            this.closeGoogleVerificationModalShow = false;
            this.GET_USERINFO_ACTION();
            this.$router.replace('/usercenter/google-verification-bind');
          }
        })
        .catch(() => {
          this.closeData.committing = false;
        });
    },
    // 绑定谷歌验证器
    _requestSetGoogleVerify(data) {
      accountManagementApi.setGoogleVerify(data)
        .then((data) => {
          if (data.errcode === 0) {
            this.$q.notify({
              message: this.$t('success.ga.bind'),
              // 可用的值: 'positive', 'negative', 'warning', 'info'
              type: 'positive',
              position: 'top', // 'top', 'left', 'bottom-left'等
            });

            this.$router.push('/usercenter/account-management');
          }
        })
        .catch(() => {
          this.committing = false;
        });
    },
    step1NextBtnClick(isApp) {
      this.currentStep = 'step2';
      this.isApp = isApp;
      if (!this.secretLoaded) {
        this.getSecret();
      }
    },
    step3NextBtnClick() {
      this.currentStep = 'step4';
    },
    copySuccess() {
      this.$q.notify({
        message: this.$t('success.copy'),
        type: 'positive',
        position: 'top',
      });
    },
    copyError() {
      // this.$q.notify({
      //   message: '秘钥复制失败！',
      //   type: 'warning',
      //   position: 'top',
      // });
    },
    showModal() {
      this.closeGoogleVerificationModalShow = true;
      this.closeData.code = '';
      this.closeData.phoneCode = '';
      this.closeData.emailCode = '';
    },
    // 发送手机验证码条件
    sendPhoneValidCondition() {
      this.$v.form.countryCode.$touch();
      if (this.$v.form.countryCode.$error) {
        return false;
      }
      if (this.Getter_User_Info.mobileStatus === 0) {
        this.$v.form.mobile.$touch();
        return !this.$v.form.mobile.$error;
      } else {
        this.$v.form.newMobilePhone.$touch();
        return !this.$v.form.newMobilePhone.$error;
      }
    },
    async renderQrString() {
      if (this.isEmpty(this.getPkgInfo)) {
        await this.getMxwPkgInfo_action();
      }

      this.qrString = JSON.stringify(this.mxwRegister.signUp(this.getPkgInfo.r));
    },
    assignEnvConfig() {
      this.btnList['max_ios_store'].path = 'https://apps.apple.com/app/id1456349663';
      this.btnList['max_android_store'].path = 'https://play.google.com/store/apps/details?id=com.maxonrow.wallet';
      this.btnList2['max_ipa'].path = window.env.maxWalletApp.ipa;
      this.btnList2['max_apk'].path = window.env.maxWalletApp.apk;
    },
    bindMaxWallet(data) {
      maxRegisterApi.bindMaxWallet(data).then(response => {
        if (!this.isUndefinedOrNullOrEmpty(response)) {
          this.$emit('update:show', false);
          this.GET_USERINFO_ACTION();
          this.notifySuccess(this.$t('success.bindMAXWallet'));
        }
      });
    },
    async initialize() {
      // As watch wouldn't be triggered on first load, change the maxRegisterModalShow here so that the bootstrap modal will show
      this.maxRegisterModalShow = this.show;
      await this.getMxwPkgInfo_action();
      this.mxwRegister = new MXWRegister(this.getPkgInfo.id, this.mxwRegisterUrl, this.mxwRegisterPath);
      this.mxwRegister.init();
      this.mxwRegister.onConnect = connected => {
        if (connected) {
          this.isConnected = true;
          this.renderQrString();
          // console.log('Max register socket connected');
        }
      };
      this.mxwRegister.onSignOn = data => {
        if (!this.isUndefinedOrNullOrEmpty(data)) {
          this.loginWithMaxWallet(JSON.stringify(data));
        }
      };

      this.mxwRegister.onSignUp = data => {
        if (!this.isUndefinedOrNullOrEmpty(data)) {
          if (this.pkgType === 'REGISTER') {
            this.registerWithMaxWallet(JSON.stringify(data));
          } else if (this.pkgType === 'GET_KYC') {
            const submitData = {
              userId: this.Getter_User_Info.id,
              data: JSON.stringify(data),
            };
            this.performKycWithMaxWallet(submitData);
          } else if (this.pkgType === 'BIND') {
            this.bindMaxWallet(JSON.stringify(data));
          }
        }
      };

      this.mxwRegister.onError = error => {
        console.error('onError error', error);
      };
      this.assignEnvConfig();
    }
  },
  computed: {
    ...mapGetters([getterTypes.Getter_User_Info, 'getPkgInfo']),
    errorMsgs() {
      let validateCodeRequired = this.Getter_User_Info.registerType === 1 ? '请填写手机验证码' : '请填写邮箱验证码';
      let validateCodeError = this.Getter_User_Info.registerType === 1 ? '手机验证码格式不正确' : '邮箱验证码格式不正确';
      return {
        validateCode: {
          required: validateCodeRequired,
          verifyCode: validateCodeError,
        },
        gaCode: {
          required: this.$t('v.common.gaCode.required'),
          gaCode: this.$t('v.common.gaCode.format'),
        },
        phoneCode: {
          requiredIf: '请输入手机验证码',
          phoneCode: '手机验证码格式不正确',
        },
        emailCode: {
          requiredIf: '请输入邮箱验证码',
          emailCode: '邮箱验证码格式不正确',
        },
      };
    },
    enableGaCheck() {
      return this.Getter_User_Info.enableGaCheck;
    },
    showMobileView() {
      // 手机，且屏幕宽度小于 992
      // return this.$q.platform.is.mobile || window.innerWidth < 992 ? '0px' : '0px 200px 15px 20px';
    },
  },
  components: {
    VerifyBtn,
    QrCode
  },
  watch: {
    show: function (val) {
      this.maxRegisterModalShow = this.show;
      if (this.show && this.isConnected) {
        this.renderQrString();
      }
    },
    maxRegisterModalShow: function (val) {
      this.$emit('update:show', val);
    },
    isConnected: function (val) {
      if (this.show && this.isConnected) {
        this.renderQrString();
      }
    },
    withKyc: function (val) {
      this.renderQrString();
    },
    Getter_User_Info(val) {
      if (!this.isEmpty(val) && val.regWalletStatus === 0) {
        this.initialize();
      }
    }
  },
  async created() {
    if (this.Getter_User_Info.regWalletStatus === 0) {
      this.initialize();
    }
  },
  beforeDestroy() {
    if (this.Getter_User_Info.regWalletStatus === 0) {
      this.mxwRegister.disconnect();
    }
  }
};
